import { BaseClient, IActionResponse, IActionResult } from "../";
import { LookupModuleRouteMap, Module } from "../../../assets/types/common";
import { ApiParams, IPagedResult, SearchDto } from "../../../assets/utils/lib";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";

export class LookupTypeClient<T> extends BaseClient {

    routes: string[] = [];
    constructor(moduleType: Module) {
        super();
        this.routes = [LookupModuleRouteMap[moduleType],"configuration"];
    }

    async getLookupTypeAsync(id?: string | undefined): Promise<T> {
        const actions: string[] = ["GetLookupCategory"];
        const params: ApiParams[] = [
            new ApiParams("categoryId", id, true)
        ];

        return await this.getAsync<T>(actions, params);
    }

    async getLookupTypesAsync(lookupTypeId?: string | undefined): Promise<T[]> {
        const actions: string[] = ["GetLookupTypes"];
        const params: ApiParams[] = [
            new ApiParams("lookupTypeId", lookupTypeId, true),
        ];

        return await this.getAsync<T[]>(actions, params);
    }

    async getAllLookupTypesAsync(): Promise<T[]> {
        const actions: string[] = ["GetAllLookupCategories"];
        const params: ApiParams[] = [];

        return await this.getAsync<T[]>(actions, params);
    }


    async searchLookupTypesAsync(searchDto: SearchDto): Promise<IPagedResult<T>> {
        const actions: string[] = ["SearchLookupCategory"];
        return await this.postAsync<SearchDto, T, IPagedResult<T>>(actions, searchDto);
    }

    async saveLookupTypeAsync(payload?: T | undefined): Promise<IActionResult<T>> {
        const actions: string[] = ["SaveLookupCategory"];
        return await this.postAsync<T>(actions, payload);
    }

    async deleteLookupTypeAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteLookupCategory"];
        const params: ApiParams[] = [
            new ApiParams("categoryId", id, true)
        ];

        return await this.deleteAsync(actions, params);
    }

    async getLookupTypesAsLookupAsync(): Promise<DropdownOption[]> {
        const actions: string[] = ["GetAllLookupCategories"];
        const params: ApiParams[] = [];

        const result: any = await this.getAsync<any>(actions, params);
        const transformedData: DropdownOption[] = result?.map((lookupCategory: any) => ({
            display: lookupCategory.name as string,
            value: lookupCategory.id as string,
            key: lookupCategory.id as string
        }));

        return transformedData;
    }
}